import { TypedUseSelectorHook, useSelector as useUntypedSelector } from "react-redux";

import type { RootState } from "../index";

const useSelector: TypedUseSelectorHook<RootState> = useUntypedSelector;

export default useSelector;
